export enum NotificationServiceActionTypes {
  APPROVE_PROJECT_PARTICIPATION = 'approveProjectParticipation',
  REJECT_PROJECT_PARTICIPATION = 'rejectProjectParticipation',
  CONFIRM_CONNECTION = 'confirmConnection',
  REJECT_CONNECTION = 'rejectConnection',
  ACCEPT_COMMUNITY_PARTICIPATION = 'acceptCommunityParticipation',
  REJECT_COMMUNITY_PARTICIPATION = 'rejectCommunityParticipation',
  ACCEPT_DOCTOR_PATIENT_LINK = 'acceptDoctorPatientLink',
  REJECT_DOCTOR_PATIENT_LINK = 'rejectDoctorPatientLink',
  REVERT_ACCOUNT_REACTIVATION = 'revertAccountReactivation',
  DECLINE_ACCOUNT_REACTIVATION = 'declineAccountReactivation',
}
